import React, { Component, Fragment, createRef } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { API_URL } from '../Actions/Config'
import AOS from "aos";
import Header from './Common/Header'
import Footer from './Common/Footer'
import Helmet from './Common/Helmet'
import ThingsListRow from "./Common/ThingsListRow"
import { getThingsToDoFilters, stoteThingsToDoDetailsUpdate, getThingsToDoListMore, getThingsToDoList } from "../Actions/ThingsToDoAction"
import "aos/dist/aos.css";
import Packery from "packery";

const mapStateToProps = (state) => {
    return {
        thingsToDoList: state.ThingsToDoList
    }
}

const mapDispatchToProps = dispatch => ({
    getThingsToDoFilters: () => dispatch(getThingsToDoFilters()),
    stoteThingsToDoDetailsUpdate: (bool) => dispatch(stoteThingsToDoDetailsUpdate(bool)),
    getThingsToDoList: (search, loc, cat) => dispatch(getThingsToDoList(search, loc, cat)),
    getThingsToDoListMore: (search, loc, cat, id, loader) => dispatch(getThingsToDoListMore(search, loc, cat, id, loader))
});


function getURL(tour) {
    var url = ""
    switch (tour.tour) {
        case "Excursion":
            url = "/things-to-do/" + tour.permalink
            break;
        default:
            break;
    }
    return url
}


function getBackgroudImage(tour) {
    var image = ""
    switch (tour.tour) {
        case "Excursion":
            image = API_URL + "/" + tour.image
            break;
        default:
            break;
    }
    return image
}

class ThingsListingPage extends Component {

    constructor(props) {
        super(props);

        this.typingTimer = null;

        this.state = {
            location: "",
            category: "",
            search_key: ""
        }

        this.gridRef = createRef();
        this.packery = null;
        this.props.getThingsToDoFilters()
    }

    componentDidMount() {

        AOS.init({
            duration: 800,
            once: true
        });

        window.scrollTo(0, 0)
        window.addEventListener("scroll", this.handleScroll)
        if (this.gridRef.current) {
            this.packery = new Packery(this.gridRef.current, {
                itemSelector: ".ttd-item",
                columnWidth: ".grid-sizer",
                percentPosition: true
            });
        }
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value }, () => this.getThingsToDoList())
    }
    handleClear = (event) => {
        this.setState({
            location: "",
            category: "",
            search_key: "",

            lastScrollTop: 0,

        }, () => this.getThingsToDoList())
    }
    componentDidUpdate(prevProps) {

        if (
            prevProps.thingsToDoList.tours !==
            this.props.thingsToDoList.tours &&
            this.packery
        ) {

            this.packery.reloadItems();
            this.packery.layout();
        }

    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }

    handleScroll = () => {

        const scrollTop = window.pageYOffset;
        if (scrollTop > this.state.lastScrollTop && this.props.thingsToDoList.toursArray) {
            this.fadeUpCards();
        }
        this.setState({ lastScrollTop: scrollTop })
    };


    fadeUpCards = () => {
        var state = this.state
        var id = this.props.thingsToDoList.tours[this.props.thingsToDoList.tours.length - 1].id
        this.props.getThingsToDoListMore(
            state.search_key,
            state.location,
            state.category,
            id,
            false
        )
    }
    getThingsToDoList() {
        var state = this.state
        this.props.getThingsToDoList(
            state.search_key,
            state.location,
            state.category
        )
    }
    handleInputChange = (event) => {

        this.setState({ [event.target.name]: event.target.value })

        clearTimeout(this.typingTimer);

        this.typingTimer = setTimeout(() => {
            this.getThingsToDoList();
        }, 2500);
    };

    render() {

        return <Fragment>
            <Header home={false} />
            <Helmet
                title={"Tour List"}
                description={"Listing"}
            />
            <div id="main-container">
                <div className="page-title">
                    <div className="container title-cont">
                        <div className="row">
                            <div className="col-lg-12 title-inner">
                                <h1 id="tour-title">Things to do</h1>
                            </div>
                        </div>
                    </div>
                </div>

            <div id="thingsTour" style={{ backgroundColor: "#f8f8f8" }}>
                <div class="container title-cont filt-bar">


                    <div class="row" >

                        <div className="col-lg-2 title-inner ">
                            <h5>Location</h5>
                            <div className="dropdown">
                                <div className="select-drop-arrow"></div>
                                <select className="btn btn-default dropdown-toggle dropdown-pref" id="location" name="location" value={this.state.location} onChange={this.handleChange}>
                                    <option data-div="full" value="">All</option>
                                    {this.props.thingsToDoList.locations.length > 0 ? this.props.thingsToDoList.locations.map((location, index) => (
                                        <option value={location.id} key={index + 1}> {location.name} </option>
                                    )) : null}
                                </select>
                            </div>
                        </div>

                        <div className="col-lg-2 title-inner ">
                            <h5>Category</h5>
                            <div className="dropdown">
                                <div className="select-drop-arrow"></div>
                                <select className="btn btn-default dropdown-toggle dropdown-pref" id="category" name="category" value={this.state.category} onChange={this.handleChange}>
                                    <option data-div="full" value="">All</option>
                                    {this.props.thingsToDoList.categories.length > 0 ? this.props.thingsToDoList.categories.map((cat, index) => (
                                        <option value={cat.id} key={cat.id}> {cat.name} </option>
                                    )) : null}
                                </select>
                            </div>
                        </div>


                        <div class="col-lg-8 search-form-wrap">
                            <div id="loadSearch">
                                <div class="row">
                                    <div className="col-md-10">
                                        <div className="input-group">
                                            <input name="search_key" value={this.state.search_key} onChange={this.handleInputChange} type="text" id="search_key" className="form-control remove-data get-input-length day-ser-bar-m" placeholder="Search for  Destinations, Attractions & Tours" />
                                            <span className="input-group-btn"> </span>
                                        </div>
                                    </div>

                                    <div class="col-md-2 day-btn-m">
                                        <span class="input-group-btn">
                                            <input class="btn btn-default remove-data" type="reset" value="reset" type="button" onClick={this.handleClear} />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>


                </div>
                <div id="myDiv">
                    <div className="page-content things-to-do" >
                        <div className="container">
                            <div className="row">
                                <div className='things-to-do-listing col-lg-12'>

                                    <div className="things-to-do-container" ref={this.gridRef}>
                                        <div className="grid-sizer"></div>

                                        {this.props.thingsToDoList.tours.length > 0 ? this.props.thingsToDoList.tours.map((tour, index) => (<ThingsListRow
                                            {...this.props}
                                            key={index}
                                            url={getURL(tour)}
                                            bgImage={getBackgroudImage(tour)}
                                            tour={tour}
                                            index={index}
                                        />))
                                            : null}
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


            </div>
            <Footer hyperLink={true}/>
        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(ThingsListingPage);